// ============================================
// ✅ CORRECCIÓN EN precioCalculator.mjs
// CON SOPORTE PARA MONEDAS MIXTAS
// ============================================

export const calcularPrecioFinal = (paquete, adultos = 1) => {
  if (!paquete) {
    return {
      precioBase: 0,
      descuentoTotalPorPersona: 0,
      descuentoTotal: 0,
      impuestos: 0,
      gastos: 0,
      total: 0,
      subtotalAdultos: 0,
      // ✅ NUEVO: Soporte para monedas mixtas
      tieneMonedasMixtas: false,
      tarifaAdicional: 0,
      monedaTarifaAdicional: 'U$S'
    };
  }

  // ✅ IMPORTANTE: La tarifa en BD YA tiene el descuento principal aplicado
  const precioBase = parseFloat(paquete.tarifa || 0);
  
  // Impuestos y gastos por persona
  const impuestosBase = parseFloat(paquete.impuestos || 0);
  const gastosBase = parseFloat(paquete.gastos_dolares || paquete.gastos_pesos || 0);

  // ✅ NUEVO: Detectar monedas mixtas
  const tarifaAdicional = parseFloat(paquete.tarifa_adicional || 0);
  const monedaTarifaAdicional = (paquete.moneda_tarifa_adicional || 'U$S').trim();
  const paqMoneda = (paquete.moneda || '$').trim();
  
  const tieneMonedasMixtas = (paqMoneda === '$' || paqMoneda === 'ARS') && 
                             tarifaAdicional > 0 && 
                             (monedaTarifaAdicional === 'U$S' || monedaTarifaAdicional === 'USD');

  // ============================================
  // CÁLCULO PARA 1 ADULTO (lista de paquetes)
  // ============================================
  if (adultos === 1) {
    // ✅ CORRECCIÓN: Si hay monedas mixtas, NO sumar tarifa_adicional al total en pesos
    const totalPesos = tieneMonedasMixtas 
      ? Math.round(precioBase + impuestosBase + gastosBase)  // Solo precio base + impuestos en pesos
      : Math.round(precioBase + impuestosBase + gastosBase + tarifaAdicional); // Todo junto si es misma moneda
    
    return {
      precioBase,
      subtotalAdultos: precioBase,
      descuentoTotalPorPersona: 0,
      descuentoTotal: 0,
      impuestos: impuestosBase,
      gastos: gastosBase,
      total: totalPesos,
      // ✅ NUEVO: Retornar datos de monedas mixtas
      tieneMonedasMixtas,
      tarifaAdicional: tieneMonedasMixtas ? tarifaAdicional : 0, // Solo si son monedas diferentes
      monedaTarifaAdicional
    };
}

  // ============================================
  // CÁLCULO PARA 2+ ADULTOS (detalle del paquete)
  // ============================================
  const subtotalAdultos = precioBase * adultos;
  let descuentoTotal = 0;

  // Descuento 2do pasajero (solo si hay 2+ adultos)
  if (adultos >= 2 && paquete.descuento_2do_pasajero_monto && parseFloat(paquete.descuento_2do_pasajero_monto) > 0) {
    if (paquete.descuento_2do_pasajero_tipo === 'porcentaje') {
      descuentoTotal += (precioBase * parseFloat(paquete.descuento_2do_pasajero_monto)) / 100;
    } else {
      descuentoTotal += parseFloat(paquete.descuento_2do_pasajero_monto);
    }
  }

  // Descuento 3er pasajero (solo UNA VEZ para el 3er pasajero)
  if (adultos >= 3 && paquete.descuento_3er_pasajero_monto && parseFloat(paquete.descuento_3er_pasajero_monto) > 0) {
    if (paquete.descuento_3er_pasajero_tipo === 'porcentaje') {
      descuentoTotal += (precioBase * parseFloat(paquete.descuento_3er_pasajero_monto)) / 100;
    } else {
      descuentoTotal += parseFloat(paquete.descuento_3er_pasajero_monto);
    }
  }

  // Impuestos y gastos totales
  const impuestosTotal = impuestosBase * adultos;
  const gastosTotal = gastosBase * adultos;

  // Total final
  const total = subtotalAdultos - descuentoTotal + impuestosTotal + gastosTotal;

  return {
    precioBase,
    subtotalAdultos,
    descuentoTotalPorPersona: 0, // Ya aplicado en la tarifa
    descuentoTotal: Math.round(descuentoTotal),
    impuestos: Math.round(impuestosTotal),
    gastos: Math.round(gastosTotal),
    total: Math.round(total),
    // ✅ NUEVO: Retornar datos de monedas mixtas
    tieneMonedasMixtas,
    tarifaAdicional,
    monedaTarifaAdicional,
    // ✅ NUEVO: Cálculo de tarifa adicional para múltiples adultos
    tarifaAdicionalTotal: tarifaAdicional * adultos
  };
};